import React, { useEffect, useRef, useState } from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { cargarArchivoFormSchema } from "../../common/validation-Schemas-carga-archivo-actualizacion-cia-client";
import { cargarArchivoAction, cargasPreviasAction, obtenerComboTipoMovimiento } from '../../store/actions/carga-archivo-actualizacion-cia-action';
import { Modal, Row, Col } from 'react-bootstrap'
import { Auth } from 'recupero-comunes';
import { getCargasPrevias } from "../../api/carga-archivo-actualizacion-cia-client";

const CargarArchivo = ({setTipoMovimientoHeader}) => {

    const { rutUsuario, rutOrganizacion, paisOrganizacion } = Auth.currentUser();
    const user = { "rutUsrCreacion": rutUsuario, "idOrganizacion": rutOrganizacion,"modulo":"caac", "codPais": paisOrganizacion };
    const [show, setShow] = useState(false)
    const fileRef = useRef();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const dataCargaMasiva = useSelector(state => state.cargaArchivoActualizacionCIAReducer);
    const {archivo, comboTipoMovimiento} = dataCargaMasiva

    const [tipoMovimiento, setTipoMovimiento] = useState('')

    const handleShow = () => setShow(true)
   
    const handleClose = () => {  
        let tipoCarga = tipoMovimiento == 273001 ? 108005 : 108006;
        const query =  Buffer.from(JSON.stringify({ "idOrganizacion": rutOrganizacion, "tipoCarga":tipoCarga})).toString('base64');
        dispatch(cargasPreviasAction(query));
        setShow(false)
       
    }
      
    useEffect(() => {

        let query2 = Buffer.from(JSON.stringify({concepto: 273})).toString('base64')
        dispatch(obtenerComboTipoMovimiento(query2))

    }, [dispatch]);
    
    const handleReloadCP = (tipoMovimiento) => {
        let tipoCarga = tipoMovimiento == 273001 ? 108005 : 108006;
        const query = Buffer.from(JSON.stringify({ "idOrganizacion": rutOrganizacion, "tipoCarga":tipoCarga})).toString('base64');
        getCargasPrevias(query);      
    };
    const getCargasPrevias = (query) => {
        setLoading(true);
        dispatch(cargasPreviasAction(query)).then(() => {
            setLoading(false);
        }); 
    };

    // El hook useFormik (formik) permite definir las propiedades del formulario. Devuelve estados y funciones de ayuda.
    const formik = useFormik({
        
        initialValues: { file: null, tipoMovimiento: null }, // Valores iniciales para cada input del formulario
        validationSchema: cargarArchivoFormSchema, // Esquema de validación de Yup para el formulario.
        onSubmit: (values) => { // Función ejecutada al invocar formik.handleSubmit()
           
            // Iniciar 'Cargando...' en botón 'Cargar Archivo'
            setLoading(true);

            // Transformar archivo en Base64
            getBase64(values.file).then((base64data) => {
                
                // Data requerida para cargar archivo. Utilizamos sintaxis spread (...) para concatenar valores de user y datos de archivo. 
                
                let data = { ...user, "filename": values.file.name, "mimetype": values.file.type, "base64data": base64data, "tipoMovimiento": values.tipoMovimiento };

                let tipoMovimiento = values.tipoMovimiento;
                if (tipoMovimiento == 273001) {//273001 Provisiones
                    data.modulo = 'caacp';
                } else {
                    if (tipoMovimiento == 273002) {//273002 Implicados/Terceros
                        data.modulo = 'caact';
                    }
                }

                // Invocar a la acción que realiza la carga del archivo
                //console.log("data: ", data);
                dispatch(cargarArchivoAction(data)).then(() => {

                    // Reseter el formulario
                    handleReset();
                    handleShow()
                    // Obtener las cargas previas.
                    handleReloadCP(tipoMovimiento);                
                   
                }).catch((error) => {
                    setLoading(false);
                    console.error(error);
                    alert(error.message);
                });
            })
            .catch((error) => {
                setLoading(false);
                console.error(error);
                alert(error.message);
            });
          
        }
    });

    const handleReset = () => {
        fileRef.current.value = "";
        setTipoMovimiento("");
        formik.resetForm();
        setLoading(false);
    }

    return (
        <div>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Respuesta de la información enviada</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                 { archivo ? archivo:"Enviando..."} 
            </Modal.Body>
            {archivo && <Modal.Footer>
                <Button variant='primary' onClick={handleClose}>
                    Aceptar
                </Button>
            </Modal.Footer>}
        </Modal>
            <Form noValidate onSubmit={formik.handleSubmit} className="mt-4">
            <Row>
            <Col md="3">
                <Form.Label
                className=' mb-0  mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                Tipo de Movimiento *
                </Form.Label>
                <br />
                <Form.Select
                className='mt-2'
                aria-label='Default select example'
                onChange={(e) => {
                    formik.handleChange(e)
                    setTipoMovimiento(e.target.value)
                    setTipoMovimientoHeader(e.target.value)
                    handleReloadCP(e.target.value);
                }}
                name='tipoMovimiento'
                value={(formik.values.tipoMovimiento = tipoMovimiento)}
                error={formik.errors.tipoMovimiento}
                >
                <option value={''}>Seleccione...</option>
                {comboTipoMovimiento && comboTipoMovimiento.comboTipoMovimiento?.map((c) => (
                    <option key={c.id} value={c.id}>
                        {c.nombre}
                    </option>
                ))}
                </Form.Select>
                {formik.errors.tipoMovimiento ? (
                <Form.Text variant='danger' style={{ color: 'red' }}>
                    {formik.errors.tipoMovimiento}
                </Form.Text>
                ) : (
                ''
                )}                      
            </Col>
            <Col md="1"></Col>
            <Col md="8">
                <Form.Label className=' mb-0  mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>Seleccione Archivo</Form.Label><br />
                <Form.Group>
                    <Form.Control ref={fileRef} type="file" name="file"
                        onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.file}
                        isValid={formik.touched.file && !formik.errors.file}
                    />
                    <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                    <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                </Form.Group>
            </Col>
            </Row>
                <hr className="mt-4" />

                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
               
                    <Button className="me-md-2" variant="warning" type="button" onClick={() => { handleReset() }}>Limpiar</Button>
                    <Button variant="danger" type="submit" disabled={loading}>
                        { loading ?
                        <div><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Cargando...</div>
                        : "Cargar Archivo" }
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default CargarArchivo;

const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
};